import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { CreateCurriculumSection } from '../create-curriculum-section';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { JobportalDrivingLicencesCard } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-extras/jobportal-driving-licence-card';
import { JobportalHobbiesCard } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-extras/jobportal-hobbies-card';
import { JobportalPersonalSummaryCard } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-extras/jobportal-personal-summary-card';
import { JobportalExtraInfoCard } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-extras/jobportal-extra-info-card';
import { fetchDrivingLicences } from '@eliadmin/core/src/api/jobportal/create-curriculum-api';
import { useQuery } from '@tanstack/react-query';
import { CacheKey } from '@eliadmin/core/src/api/constants';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

export const CreateCurriculumStep8 = () => {
  const { t } = useTranslations();
  const locale = useLocaleStore(state => state.currentLocale);

  const { data: drivingLicences } = useQuery({
    queryKey: [CacheKey.JOBPORTAL_DRIVER_LICENCES],
    queryFn: () => fetchDrivingLicences({ locale }),
  });

  return (
    <div className={cn('create-curriculum-step-wrapper flex w-full flex-col gap-4')}>
      <CreateCurriculumSection title={t('text867')}>
        <p className="text-[#63626F]">{t('text1754')}</p>
        <JobportalDrivingLicencesCard drivingLicences={drivingLicences?.data || []} />
        <JobportalHobbiesCard />
        <JobportalPersonalSummaryCard />
        <JobportalExtraInfoCard />
      </CreateCurriculumSection>
    </div>
  );
};
